export default __webpack_public_path__ + "static/media/1143.10c6a9d5.png";